import constant from "../../util/constant";
import {
  PARTNER_LOOKUP_API_REQUEST,
  PARTNER_LOOKUP_API_END,
  GET_PARTNER_LOOKUP_SUCCESS,
  GET_PARTNER_LOOKUP_FAILURE,
  GET_OFFER_LIST_SUCCESS,
  GET_OFFER_LIST_FAILURE,
  PARTNER_OFFER_NAMES_API_REQUEST,
  PARTNER_OFFER_NAMES_API_END
} from "../actionTypes";

const { API_STATUS } = constant;

const DEFAULT_STATE = {
  loading: false,
  message: "",
  status: "",
  apiType: "",
  lookup: {},
  offerNames: [],
};

export const partnerLookup = ( state = DEFAULT_STATE, action = "" ) => {
  switch ( action.type ) {
    case PARTNER_LOOKUP_API_REQUEST:
      return {
        ...state,
        status: API_STATUS.START,
        apiType: action.payload,
      };
    case PARTNER_LOOKUP_API_END:
      return {
        ...state,
        status: API_STATUS.END,
        apiType: "",
      };
    case GET_PARTNER_LOOKUP_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        lookup: action.payload,
      };
    case GET_PARTNER_LOOKUP_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        lookup: {},
      };
    default:
      return state;
  }
};

export const partnerOfferNames = ( state = DEFAULT_STATE, action = "" ) => {
  switch ( action.type ) {
    case PARTNER_OFFER_NAMES_API_REQUEST:
      return {
        ...state,
        status: API_STATUS.START,
        apiType: action.payload,
      };
    case PARTNER_OFFER_NAMES_API_END:
      return {
        ...state,
        status: API_STATUS.END,
        apiType: "",
      };
    case GET_OFFER_LIST_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        offerNames: action.payload,
      };
    case GET_OFFER_LIST_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        offerNames: [],
      };
    default:
      return state;
  }
};

